import { documentTypesLocales as libDocumentTypesLocales } from '@shinetools/shine-start-library';
import LocalizedStrings from 'localized-strings';

import { ShineStartDocument } from '__generated__/GQL';
import asBentoPage from 'common/bento/hoc/asBentoPage';
import Callout from 'components/_core/Callout';
import Header from 'features/Onboarding/components/Header';
import OBFileItem from 'features/Onboarding/components/OBFileItem';
import OBNavigation from 'features/Onboarding/components/OBNavigation/OBNavigation';
import OBStickyButton from 'features/Onboarding/components/OBStickyButton/OBStickyButton';
import getShineStartDocumentError from 'features/Onboarding/modules/ShineStartVerification/libs/getShineStartDocumentError';

import locales from './locales';

const documentTypesLocales = new LocalizedStrings(libDocumentTypesLocales);

interface HandwrittenIdentityRefusedProps {
  onNext: () => void;
  document: ShineStartDocument;
}
const HandwrittenIdentityRefused = asBentoPage<HandwrittenIdentityRefusedProps>(
  ({ document, Layout, onNext, onPrev }) => {
    const { url } = document;

    if (!url) {
      throw Error('Document url should be defined');
    }

    const documentLabel =
      documentTypesLocales.PROOF_OF_IDENTITY_HAND_WRITTEN.label;

    return (
      <Layout nav={<OBNavigation onPrev={onPrev} />}>
        <Header title={locales.title} />

        <Callout marginBottom="space-24" variant="error">
          <Callout.Content>
            {getShineStartDocumentError(document)}
          </Callout.Content>
        </Callout>

        <OBFileItem
          fileName={documentLabel}
          onPreviewClick={() => window.open(url, '_blank')}
        />

        <OBStickyButton icon="add-file" iconPosition="left" onClick={onNext}>
          {locales.replaceDocCta}
        </OBStickyButton>
      </Layout>
    );
  },
);

export default HandwrittenIdentityRefused;
